function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInletPressure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2759",
    d: "M20 2.5A17.5 17.5 0 1 1 2.5 20 17.5 17.5 0 0 1 20 2.5M20 0a19.979 19.979 0 1 0 .043 0H20",
    style: {
      fill: "#4b97ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2760",
    d: "M23.375 16.844c0-1.822-3.375-6.505-3.375-6.505s-3.375 4.683-3.375 6.505a3.376 3.376 0 0 0 6.75 0M21.5 15.751a.91.91 0 0 1 .858.833.858.858 0 1 1-.858-.833",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2761",
    d: "M21.041 27.543v-3a9.391 9.391 0 0 0 2.09-.509 9.309 9.309 0 0 0 5.825-10.772l-.567-1.716-.024-.06a9.324 9.324 0 1 0-9.824 13.033v3.02h-2.02l1.328 1.25h12.678v-1.25zm-8.5-15.577a8.063 8.063 0 0 1 14.675.008l.54 1.622a8.064 8.064 0 1 1-15.215-1.63",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2762",
    d: "M16.459 31.34h14.068v-1.25H17.7z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2763",
    d: "M17.017 29.344 11.8 24.433l.057 3.11h-2.8v1.25h2.824l.024 1.3H9.054v1.25h2.87l.057 3.092z",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInletPressure);
export default __webpack_public_path__ + "static/media/inlet-pressure.b771d79307b7a0606c3dd4eec0f96ca7.svg";
export { ForwardRef as ReactComponent };